module.exports = __webpack_public_path__ + "img/pulic_2.8a098e65.png";